var _g, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatYoullNeedSubhead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 785.92 96.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0,21.12h14.15l10.98,34.54,11.09-34.54h13.73l10.77,33.8,11.2-33.8h14.15l-17.96,52.81h-13.73l-11.3-36.12-11.41,36.12h-13.73L0,21.12Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.27,0h13.94v27.88c3.49-5.28,8.77-8.03,15.32-8.03,12.57,0,19.75,7.39,19.75,24.19v29.89h-13.94v-27.04c0-10.67-4.01-13.84-9.93-13.94-7.18-.11-11.2,4.54-11.2,13.31v27.67h-13.94V0Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.51,59.04c0-11.3,7.92-17,21.55-17h12.46c-.95-6.34-3.91-10.03-9.72-10.03-4.54,0-8.24,1.9-10.77,6.02l-12.25-4.22c2.85-6.76,9.72-13.94,23.03-13.94,16.05,0,23.98,9.72,23.77,24.82l-.32,29.26h-12.99l-.21-6.13c-2.75,4.75-7.5,7.39-14.58,7.39-12.67,0-19.96-5.81-19.96-16.16Zm34.33-6.65h-7.92c-9.19,0-12.15,2.32-12.15,6.23,0,3.06,2.96,4.96,8.03,4.96,6.87,0,12.04-5.7,12.04-11.2Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.68,58.51v-25.56h-8.56v-11.83h8.56V4.65h13.94v16.48h13.2v11.83h-13.2v22.5c0,4.65,1.9,6.87,5.81,6.87,1.37,0,3.06-.63,4.96-1.9l4.86,10.46c-3.49,2.54-7.82,4.33-11.83,4.33-11.72,0-17.74-5.92-17.74-16.69Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.46,92.63l5.18-11.3c2.32,1.27,4.44,2.11,6.02,2.11,2.96,0,5.28-1.48,6.65-4.75l2.22-5.28-23.87-52.28h15.32l15,36.54,14.36-36.54h15.32l-23.98,57.35c-4.54,10.67-8.34,17.85-19.86,17.85-3.8,0-8.77-1.69-12.36-3.7Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.56,47.53c0-16.27,11.41-27.67,27.46-27.67s27.57,11.41,27.57,27.67-11.3,27.67-27.36,27.67-27.67-11.41-27.67-27.67Zm40.77,0c0-8.66-5.49-14.79-13.31-14.79s-13.2,6.13-13.2,14.79,5.49,14.79,13.41,14.79,13.1-6.13,13.1-14.79Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.59,62.1c7.29.11,11.2-4.54,11.2-13.31v-27.67h13.94v52.81h-13.1l-.63-7.08c-3.49,5.39-8.77,8.34-15.42,8.34-12.57,0-19.75-7.39-19.75-24.19v-29.89h13.94v27.04c0,10.67,3.91,13.84,9.82,13.94Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.57,0h14.47l-10.35,24.93h-10.56l6.44-24.93Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.9,0h13.94v73.93h-13.94V0Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.88,0h13.94v73.93h-13.94V0Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m558,21.12h13.1l.63,7.08c3.49-5.39,8.87-8.34,15.53-8.34,12.57,0,19.75,7.39,19.65,24.19v29.89h-13.94v-27.04c0-10.67-3.91-13.84-9.82-13.94-7.29-.11-11.2,4.54-11.2,13.31v27.67h-13.94V21.12Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m615.15,47.53c0-16.27,11.41-27.67,27.46-27.67,13.84,0,25.77,11.3,25.77,31.37h-38.66c.63,7.18,6.87,11.51,13.62,11.51,5.81,0,9.29-2.75,11.3-6.65l12.46,4.86c-4.54,8.98-12.78,14.26-25.24,14.26-15.63,0-26.72-11.41-26.72-27.67Zm15.31-6.65h22.81c-.63-6.65-6.55-9.19-11.09-9.19s-10.99,2.53-11.72,9.19Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m673.66,47.53c0-16.27,11.41-27.67,27.46-27.67,13.84,0,25.77,11.3,25.77,31.37h-38.66c.63,7.18,6.87,11.51,13.62,11.51,5.81,0,9.29-2.75,11.3-6.65l12.46,4.86c-4.54,8.98-12.78,14.26-25.24,14.26-15.63,0-26.72-11.41-26.72-27.67Zm15.31-6.65h22.81c-.63-6.65-6.55-9.19-11.09-9.19s-10.99,2.53-11.72,9.19Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m732.18,47.53c0-16.9,9.29-27.67,23.87-27.67,6.97,0,12.36,2.96,15.84,8.34V0h13.94v73.93h-13.2l-.53-7.29c-3.49,5.49-8.98,8.56-16.05,8.56-14.58,0-23.87-10.77-23.87-27.67Zm39.71,1.58v-3.17c-.63-7.92-5.49-13.2-12.36-13.2-7.5,0-12.89,6.13-12.89,14.79s5.49,14.89,12.99,14.89c6.76,0,11.62-5.39,12.25-13.31Z",
    fill: "#2c3037"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.33,
    y: 85.87,
    width: 264.58,
    height: 11.01,
    fill: "#35c0e2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 315.33,
    y: 85.87,
    width: 470.58,
    height: 11.01,
    fill: "#35c0e2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatYoullNeedSubhead);
export default __webpack_public_path__ + "static/media/what-youll-need-subhead.bd6d4ca4d4835b0d4805fd0438e68e1f.svg";
export { ForwardRef as ReactComponent };